<template>
    <v-card>
        <v-card-text>
            <v-container fluid>
                <v-layout row wrap id="text-wrapper">
                    <v-flex xs12 text-xs-center>
                        <h5>{{ infoTournament.name }}</h5>
                    </v-flex>
                    <v-flex xs12 text-xs-center mt-2>
                        <div></div>
                    </v-flex>
                </v-layout>
                <!--<v-layout row wrap>
                    <v-flex xs12>
                        <v-list two-line class="list-height">
                            <template v-for="team in infoTournament.teams">
                                <v-divider></v-divider>
                                <v-list-tile avatar :key="team.name">
                                    <v-list-tile-avatar>
                                        <img :src="team.logo">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="team.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="team.rol"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-flex>
                </v-layout>-->
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Tournament",
        props: {
            infoTournament: {required: true}
        },
        data() {
            return {
            }
        }
    }
</script>

<style lang="css" scoped>
    .list-height {
        max-height: calc(650px - 200px);
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/partnering/Tournament.vue